import { ColumnViewModel } from '../../shared/column-types';

export const VARIANTS_VDA_EVIDENCE: ColumnViewModel = {
  columns: [
    'variantStrID',
    'geneSymbol',
    'diseaseName',
    'diseaseUMLSCUI',
    'geneNcbiIDs',
    'score',
    'sourceScore',
    'gof_lof',
    'associationType',
    'ancestry_name',
    'sentenceHTML',
    'text',
    'chemsInSentence',
    'chemIDs',
    'chemical_effect',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'source',
    'pValue',
    'riskAllele',
    'diseaseType',
    'diseaseClassName_MSH',
    'diseaseClassName_UMLS',
    'diseaseClassName_DO',
    'diseaseClassName_HPO',
    'beta',
    'odds_ratio',
    'clinical_significance',
    'association',
    'citation_count',
    'icite_apt',
  ],
  defaultVisible: [
    'variantStrID',
    'geneSymbol',
    'diseaseName',
    'score',
    'sourceScore',
    'associationType',
    'ancestry_name',
    'sentenceHTML',
    'chemsInSentence',
    'pmid',
    'pmYear',
    'journal_abbrv',
    'riskAllele',
    'beta',
    'odds_ratio',
  ],
};